function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import Common from '../components/includes/Common';
import { Container, Col, Row, ControlLabel } from 'react-bootstrap';
import { message, Skeleton, Descriptions } from 'antd';
import ChangePassword from "../components/forms/ChangePassword";
import { PersonCircle } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AccountConfig = function AccountConfig() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getuser/' + Common.currentUser.id + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUser(response.data.user);
      } else {
        message.error({
          content: response.data.message,
          duration: 3
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenuee',
        duration: 3
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "cool-radius",
            style: {
              background: '#FCB31C'
            },
            children: [user != null && /*#__PURE__*/_jsx(Container, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  sm: 3,
                  xs: 3,
                  children: /*#__PURE__*/_jsx(PersonCircle, {
                    size: 55
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 8,
                  md: 8,
                  sm: 9,
                  xs: 9,
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    title: "Info Utilisateur",
                    column: 1,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Login",
                      children: user.mobile.slice(3)
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "P\xE9nom",
                      children: user.firstname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: "Nom",
                      children: user.lastname
                    })]
                  })
                })]
              })
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 7,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg",
            children: /*#__PURE__*/_jsx(ChangePassword, {
              user: user
            })
          })
        })]
      })
    })
  });
};
export default AccountConfig;